import { teamManage } from './teamManage'
import header from './header'
import couponPay from './couponPay'
import { home } from './home'
import sendCouponHistory from './sendCouponHistory'
import sendCouponDetailList from './sendCouponDetailList'

import purchaseCouponHistory from './purchaseCouponHistory'
import { selectAddress, fenceData } from './selectAddress'
import {sendCoupon} from './sendCoupon'
import purchase from './purchase'
import recharge from './recharge'
import {invoice} from './invoice'

export default {
  teamManage,
  sendCouponHistory,
  sendCouponDetailList,
  purchaseCouponHistory,
  selectAddress,
  fenceData,
  header,
  home,
  sendCoupon,
  couponPay,
  purchase,
  recharge,
  invoice
}
